module.exports = "<section class=\"main-container\">\n\n  <page-header></page-header>\n\n  <div class=\"container-fluid page-content\" style=\"height: 100%;\">\n\n    <div class=\"row\" style=\"height: 500px;\">\n\n      <pdf-viewer [url]=\"url\" [css]=\"'width:100%; height:100%'\"></pdf-viewer>\n\n    </div>\n\n  </div>\n\n  <page-footer></page-footer>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/area-cliente/minhas-fichas/pdf-ficha-cliente.component.html
// module id = ./src/app/area-cliente/minhas-fichas/pdf-ficha-cliente.component.html
// module chunks = main